import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { omit } from 'ramda';

import { parseQuery, stringifyQuery } from 'utils';
import { FilterObject } from 'types';

export const useUrlQuery = <T extends object = FilterObject>() => {
  const history = useHistory();
  const { search } = useLocation();

  const { parsedQuery } = useMemo(() => {
    const parsedQuery = parseQuery<T>(search);

    return { parsedQuery };
  }, [search]);

  const filters = useMemo(
    () => omit(['pageSize', 'pageIndex', 'sortBy', 'sortOrder'], parsedQuery),
    [parsedQuery],
  );
  const pushQuery = useCallback(
    (data: T) => {
      history.push({
        ...history,
        search: stringifyQuery(data),
      });
    },
    [history],
  );

  const replaceQuery = useCallback(
    (data: T) => {
      history.replace({
        ...history,
        search: stringifyQuery(data),
      });
    },
    [history],
  );

  return {
    parsedQuery,
    filters,
    pushQuery,
    replaceQuery,
  };
};
